export enum ProjectPlan{
    PRO,
    ESSENTIALS,
    STARTER,
    CUSTOM
}